import React from "react";
import styles from "./whyChooseService.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCode, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import LazyText from "../../../common/imagescroll/LazyText";
import CTAButton from "../../../v2/common/CTA-Button/cta-button";

const WhyChooseService: React.FC = () => {
    const { t } = useTranslation();


    const whyChooseService = [
        {
            title: "100% Custom-Made Designs",
            description: "Built from scratch for your business—no templates, fully tailored to your brand and goals."
        },
        {
            title: "Clear Communication",
            description: "Short, transparent updates so you always know what’s happening and what to expect."
        },
        {
            title: "Fair Pricing",
            description: "Straightforward rates with no surprises, maximum value for your investment."
        },
        {
            title: "Modern Tech Stack",
            description: "Up-to-date technologies for long-term performance, speed, and scalability."
        },
        {
            title: "Post-Launch Support",
            description: "We monitor performance and make improvements as needed after launch."
        }
    ];


    return (
        <section className={styles.sectionWrapper}>

            {/* CENTERED TITLES INSIDE SECTION */}
            <LazyText>
                <h1 className="sectionTitle" style={{color:"darkturquoise"}}>
                    {/*{String(t('homePage.whyUsTitle'))}*/}
                    Why Choose This Service
                </h1>
            </LazyText>


            {/* YOUR GRID — UNTOUCHED */}
            <div className={styles.gridContainer}>
                {whyChooseService.map((benefit, index) => (

                    <div className={styles.card}>
                        <div className={styles.card_title}>
                            {benefit.title}
                        </div>
                        <div className={styles.content}>
                            <p>
                                {benefit.description}
                            </p>
                        </div>
                    </div>

                ))}
            </div>
            <CTAButton text={"Get a Free Quote"} />
        </section>
    );
};

export default WhyChooseService;
